import React, { useLayoutEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames/bind';

import cosmicToyImg from '../../styles/theme/disney/Toy-Story-Movie-Cosmic_Toy.png';
import styles from './DisneyCosmicToy.styl';

const cx = classNames.bind(styles);

const SIDEBAR_SELECTOR = '[data-theme-sidebar]';

function rectsOverlap(a, b) {
  return !(a.right <= b.left || a.left >= b.right || a.bottom <= b.top || a.top >= b.bottom);
}

export default function DisneyCosmicToy() {
  const alienRef = useRef(null);
  const [isHidden, setIsHidden] = useState(false);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const alien = alienRef.current;

    if (!alien) {
      return undefined;
    }

    const observedSidebars = new WeakSet();

    const observeSidebars = () => {
      document.querySelectorAll(SIDEBAR_SELECTOR).forEach(sidebar => {
        if (!observedSidebars.has(sidebar)) {
          resizeObserver.observe(sidebar);
          observedSidebars.add(sidebar);
        }
      });
    };

    const checkOverlap = () => {
      observeSidebars();

      const alienRect = alien.getBoundingClientRect();

      if (!alienRect.width || !alienRect.height) {
        return;
      }

      const sidebars = document.querySelectorAll(SIDEBAR_SELECTOR);
      let overlaps = false;

      sidebars.forEach(sidebar => {
        const sidebarRect = sidebar.getBoundingClientRect();

        if (sidebarRect.width && sidebarRect.height && rectsOverlap(alienRect, sidebarRect)) {
          overlaps = true;
        }
      });

      setIsHidden(overlaps);
    };

    const resizeObserver = new ResizeObserver(checkOverlap);

    resizeObserver.observe(alien);
    observeSidebars();
    checkOverlap();

    window.addEventListener('scroll', checkOverlap, { passive: true });
    window.addEventListener('resize', checkOverlap, { passive: true });

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('scroll', checkOverlap);
      window.removeEventListener('resize', checkOverlap);
    };
  }, [pathname]);

  return (
    <img
      ref={alienRef}
      className={cx('DisneyCosmicToy', { DisneyCosmicToy_hidden: isHidden })}
      src={cosmicToyImg}
      alt=""
      aria-hidden="true"
    />
  );
}
